module.exports = __webpack_public_path__ + "static/media/eboxlogo.a12ea512.webp";